import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('NotificationsBellController', NotificationsBellController);

    /** @ngInject */
    function NotificationsBellController(
        $state,
        $rootScope,
        $interval,
        NotificationsFactory
    ) {
        var vm = this;

        function setWindowTitle(number) {
            if (number != 0) {
                document.title = '(' + number + ') iWykonawca.pl';
            }

            if (number < 99) {
                document.title = 'iWykonawca.pl';
            }

            if (number > 99) {
                document.title = '(99+) iWykonawca.pl';
            }
        }

        function readHowManyElementsFromBackend() {
            NotificationsFactory.count().then(function (howManyUnread) {
                vm.countElements = howManyUnread.data.count;
                setWindowTitle(vm.countElements);
            });
        }

        $interval(function () {
            readHowManyElementsFromBackend();
        }, 300000);

        $rootScope.$on('refreshBell', function (event) {
            readHowManyElementsFromBackend();
        });

        readHowManyElementsFromBackend();
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/notifications/bell/notifications-bell.controller.ts